import React, { useEffect, useState } from 'react'
import { GreenTick, Gold, GuestStar, Silver } from '../../../assests/ExportImageIcon'
import service from '../../../services/service'
import endpoints from '../../../services/endpoints'
import './mySubscription.css'

const DEFAULT_WHY_UPGRADE = [
    'Unlock advanced AI features and unlimited itinerary planning',
    'Get priority support and faster refunds/cancellations',
    'Access exclusive luxury packages and airport lounges',
    'Earn more rewards and get special discounts on all bookings',
]

const getPlanIcon = (planType) => {
    const type = (planType || '').toLowerCase()
    if (type === 'gold') return Gold
    if (type === 'silver') return Silver
    return GuestStar
}

const MySubscription = ({ onManage, onUpgrade }) => {
    const [billingCycle, setBillingCycle] = useState('monthly')
    const [plans, setPlans] = useState([])
    const [whyUpgrade, setWhyUpgrade] = useState(DEFAULT_WHY_UPGRADE)
    const [yearlyToggleLabel, setYearlyToggleLabel] = useState('Yearly (Save Up To 17%)')
    const [currency, setCurrency] = useState('')
    const [allowedGateways, setAllowedGateways] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        let mounted = true
        setLoading(true)

        service.get(endpoints.subscriptions.plans, { billing_cycle: billingCycle }, { silent: true })
            .then(({ data }) => {
                if (!mounted) return
                const body = data?.data || {}
                setPlans(Array.isArray(body.plans) ? body.plans : [])
                setCurrency(body.currency || '')
                setAllowedGateways(Array.isArray(body.allowed_gateways) ? body.allowed_gateways : [])
                if (Array.isArray(body.why_upgrade) && body.why_upgrade.length > 0) {
                    setWhyUpgrade(body.why_upgrade)
                }
                if (body.yearly_toggle_label) {
                    setYearlyToggleLabel(body.yearly_toggle_label)
                }
            })
            .catch(() => {
                if (!mounted) return
                setPlans([])
            })
            .finally(() => {
                if (mounted) setLoading(false)
            })

        return () => { mounted = false }
    }, [billingCycle])

    return (
        <div className='subscriptionPlan'>
            <div className='subscriptionTopRow'>
                <div className='subscriptionToggle'>
                    <div className='commonBookingTab'>
                        <div
                            className={`bookTab ${billingCycle === 'monthly' ? 'active' : ''}`}
                            onClick={() => setBillingCycle('monthly')}
                        >
                            Monthly
                        </div>
                        <div
                            className={`bookTab ${billingCycle === 'yearly' ? 'active' : ''}`}
                            onClick={() => setBillingCycle('yearly')}
                        >
                            {yearlyToggleLabel}
                        </div>
                    </div>
                </div>
                <span className='subscriptionManageLink' onClick={onManage}>Manage Subscription</span>
            </div>

            {loading ? (
                <p className='securityMenuItem__subtitle mt-3'>Loading plans...</p>
            ) : plans.length === 0 ? (
                <p className='securityMenuItem__subtitle mt-3'>No plans available right now.</p>
            ) : (
                <div className='subscriptionPlansGrid'>
                    {plans.map((plan) => {
                        const isHighlighted = plan.badge === 'most_popular' || plan.badge === 'featured'
                        const priceLabel = `${plan.currency_symbol || ''}${plan.display_price ?? ''}${plan.price_suffix || ''}`
                        return (
                            <div
                                className={`subscriptionPlanCard bgWhite commonBorder borderRadius20 paddingCommon20 ${isHighlighted ? 'subscriptionPlanCard--highlighted' : ''}`}
                                key={plan.plan_id}
                            >
                                {plan.badge_label && (
                                    <span className='subscriptionPlanCard__badge'>{plan.badge_label}</span>
                                )}

                                <div className='subscriptionPlanCard__head'>
                                    <span className={`subscriptionPlanCard__icon subscriptionPlanCard__icon--${(plan.plan_type || '').toLowerCase()}`}>
                                        <img src={plan.icon || getPlanIcon(plan.plan_type)} alt="" />
                                    </span>
                                    <div className='subscriptionPlanCard__headInfo'>
                                        <div className='subscriptionPlanCard__name'>{plan.name}</div>
                                        {plan.description && <div className='subscriptionPlanCard__tagline'>{plan.description}</div>}
                                        <div className='subscriptionPlanCard__price'>{priceLabel}</div>
                                        {plan.savings_label && (
                                            <div className='subscriptionToggle__save'>{plan.savings_label}</div>
                                        )}
                                    </div>
                                    {plan.is_current && (
                                        <span className='langRadio langRadio--checked subscriptionPlanCard__check'>
                                            <img src={GreenTick} alt="" />
                                        </span>
                                    )}
                                </div>

                                {plan.features?.length > 0 && (
                                    <ul className='subscriptionFeatureList'>
                                        {plan.features.map((feature, index) => {
                                            const text = typeof feature === 'string' ? feature : feature.text
                                            const bold = typeof feature === 'object' && feature.bold
                                            return (
                                                <li key={index} className={bold ? 'subscriptionFeatureList__bold' : ''}>
                                                    <img src={GreenTick} alt="" />
                                                    <span>{text}</span>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                )}

                                {plan.show_upgrade_button && (
                                    <button
                                        type='button'
                                        className='commonBtn w-100'
                                        onClick={() => onUpgrade?.({ plan, billingCycle, currency, allowedGateways })}
                                    >
                                        {plan.upgrade_button_label || plan.upgrade_label || `Upgrade to ${plan.name}`}
                                    </button>
                                )}
                            </div>
                        )
                    })}
                </div>
            )}

            <div className='bsSectionTitle mt-4'>Why Upgrade ?</div>
            <div className='bsBox'>
                <ul className='subscriptionFeatureList'>
                    {whyUpgrade.map((text, index) => (
                        <li key={index}>
                            <img src={GreenTick} alt="" />
                            <span>{text}</span>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    )
}

export default MySubscription
